<article class="Tile Tile--{{ color }}" [class.Tile--filled]="type === ETileType.filled">
	<p class="Tile__label FontSize--{{ fontSizeLabel }}" [class.Tile__label--uppercase]="uppercase">
		@if(isIcon){
			<app-icon [icon]="icon" iconSize="small" />
		}
		{{ name }}
		@if(isButton) {
			<section class="Button">
				<mat-slide-toggle [(ngModel)]="isChecked" (change)="onClicked()" [disabled]="isDisabled()" color="succes"></mat-slide-toggle>
			</section>
		}
		@if(tooltipText) {
			<app-info-tooltip 
				class="Tile__info" 
				[tooltipText]="tooltipText" 
				tooltipPosition="above" 
				iconColor="white"
			/>
		}
	</p>
	<p class="Tile__value FontSize--{{ fontSize }}">
		{{ value ?? '—' }}
	</p>
</article>

